module.exports = __webpack_public_path__ + "media/1x1/hk-4a0f09ba.svg";